export default {
  path: '/2019LJBY',
  name: '2019LJBY',
  component: () => import('./home.vue'),
  base: '/2019LJBY/',
  redirect: '/2019LJBY/List',
  meta: {
    title: '“两江榜样”-先进就在身边，榜样引领前行。',
  },
  children: [
    {
      path: 'Rule',
      component: () => import('./Rule.vue'),
      name: 'HandcraftPaperRule',
      meta: {
        title: '“两江榜样”-先进就在身边，榜样引领前行。',
      },
    },

    {
      path: 'Rule2',
      component: () => import('./Rule2.vue'),
      name: 'HandcraftPaperRule',
      meta: {
        title: '“两江榜样”-先进就在身边，榜样引领前行。',
      },
    },

    {
      path: 'List',
      component: () => import('./List.vue'),
      name: 'HandcraftPaperList',
      meta: {
        title: '“两江榜样”-先进就在身边，榜样引领前行。',
      },
    },

    {
      path: 'DetailPage',
      component: () => import('./DetailPage.vue'),
      name: 'HandcraftPaperDetail',
      meta: {
        title: '“两江榜样”-先进就在身边，榜样引领前行。',
      },
    },
    {
      path: 'JumpPage',
      component: () => import('./JumpPage.vue'),
      name: 'HandcraftPaperJumpPage',
      meta: {
        title: '“两江榜样”-先进就在身边，榜样引领前行。',
      },
    },
  ],
};
